import styled from 'styled-components/macro';

export const StyledFakeLabel = styled.span`
  font-size: var(--font-size-sm);
  line-height: 1;
  color: var(--secondary-text-color);
`;

export const RequiredAsterisk = styled.span`
  color: var(--danger);
  margin-left: 3px;
`;
